var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like_img_wrap"},[_c('div',{staticClass:"like_img"}),_c('span',{staticClass:"like_count"},[_vm._v("251")])])
}]

export { render, staticRenderFns }